import { ConfigService, SystemUrlService } from "@xo/client-common";

export class Type12RichTextUrlService extends SystemUrlService {
    constructor(system: string, configService: ConfigService) {
        super(system, "SpecApp", "Type12RichText", configService);
    }
}
